import { createSlice } from "@reduxjs/toolkit";

import { invoicesApi } from "../services/invoices";
import type { RootState } from "../../store";
import type { Invoice } from "../../types/InvoiceTypes";

type State = {
  data: Invoice | undefined;
  step: number;
};

const initialState: State = {
  data: undefined,
  step: 1,
};

export const MAX_STEPS = 4;

const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    resetStep(state) {
      state.step = 1;
    },
    nextStep(state, { payload: skipNext = false }) {
      state.step = state.step + (skipNext ? 2 : 1);
    },
    previousState(state, { payload: skipPrev = false }) {
      state.step = state.step - (skipPrev ? 2 : 1);
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        invoicesApi.endpoints.getInvoice.matchFulfilled,
        (state, { payload }) => {
          state.data = payload;
        }
      )
      .addMatcher(
        invoicesApi.endpoints.getInvoicePublic.matchFulfilled,
        (state, { payload }) => {
          state.data = payload;
        }
      )
      .addMatcher(
        invoicesApi.endpoints.updateInvoice.matchFulfilled,
        (state, { payload }) => {
          state.data = payload;
        }
      );
  },
});

export default invoiceSlice.reducer;

export const selectInvoice = (state: RootState) => state.invoice.data;
export const selectStep = (state: RootState) => state.invoice.step;

export const { resetStep, nextStep, previousState } = invoiceSlice.actions;
